module.exports = __webpack_public_path__ + "media/svg/tv-25525747.svg";